import React from 'react';
import { Star, Quote } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Camila',
    text: 'Lloraba todas las noches porque no sabía qué hacer. En 2 semanas ya tenía rutina y me sentí otra persona.'
  }, {
    name: 'Julieta',
    text: 'Los berrinches me hacían sentir la peor mamá. Ahora los manejo sin gritos y sin culpa.'
  }, {
    name: 'Sofía',
    text: 'Dejé de googlear todo a las 3am. Ahora tengo un sistema y duermo tranquila.'
  }, {
    name: 'Valentina',
    text: 'Es tan práctico que lo apliqué el mismo día. No necesitás pensar, solo seguir los pasos.'
  }, {
    name: 'Florencia',
    text: 'Sentía que todas las mamás sabían algo que yo no. Este sistema me dio la seguridad que me faltaba.'
  }, {
    name: 'Rocío',
    text: 'Las 100 actividades me salvaron. Ya no improviso, tengo todo listo para cada edad.'
  }, {
    name: 'Lucía',
    text: 'Me sacó la culpa. No lo estaba haciendo mal, solo me faltaba información.'
  }, {
    name: 'Martina',
    text: 'Ojalá lo hubiera tenido desde el día 1. Te ahorra meses de prueba y error.'
  }];
  const microTestimonials = ['En 1 semana ya dormíamos mejor', 'Por fin entendí por qué lloraba', 'Dejé de sentirme perdida', 'Ahora tengo estructura y calma', 'Me devolvió la confianza'];
  return <section className="bg-white py-24 px-6" data-id="element-246">
      <div className="max-w-6xl mx-auto" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-black mb-4" data-id="element-249">
            Mamás reales. Resultados reales.
          </h2>
          <div className="flex justify-center gap-1 text-brand-gold mb-4" data-id="element-250">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-251" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-252">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-cream rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow relative" data-id="element-253">
              <Quote className="absolute top-4 right-4 w-8 h-8 text-brand-sage/10" data-id="element-254" />
              <div className="flex gap-1 text-brand-gold mb-3" data-id="element-255">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-256" />)}
              </div>
              <p className="text-brand-charcoal mb-4 italic" data-id="element-257">"{t.text}"</p>
              <p className="font-bold text-brand-sage" data-id="element-258">— {t.name}</p>
            </div>)}
        </div>

        <div className="bg-brand-sage/5 rounded-3xl p-8 text-center max-w-4xl mx-auto border border-brand-sage/10 mb-12" data-id="element-259">
          <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-260">
            {microTestimonials.map((mt, i) => <span key={i} className="bg-white px-4 py-2 rounded-full text-sm font-medium text-brand-charcoal shadow-sm border border-brand-sage/10" data-id="element-261">
                • "{mt}"
              </span>)}
          </div>
          <p className="text-2xl font-serif text-brand-black" data-id="element-262">
            👉 Si ellas pudieron, vos también.
          </p>
        </div>

        <div className="text-center" data-id="element-263">
          <CTAButton text="QUIERO LO MISMO PARA MÍ" data-id="element-264" />
          <p className="text-sm text-brand-red font-bold mt-3" data-id="element-265">
            Todo por solo $19.990 — Oferta por tiempo limitado
          </p>
        </div>
      </div>
    </section>;
}